export enum ProcurementCreationStatus {
  Draft = 1,
  Submitted = 2,
}

export enum ProcurementPriority {
  Low = 1,
  Normal = 2,
  High = 3,
  Critical = 4,
}

export enum QuoteType {
  Document = 1,
  Manual = 2,
}

export enum PurchaseRequestItemType {
  Item = 1,
  Text = 2,
}

export enum InventoryTrackingMode {
  None = 1,
  Batch = 2,
  Lot = 3,
  Serial = 4,
}

export enum LifecycleExpirationType {
  None = 1,
  ExpiryDate = 2,
  ShelfLifeDays = 3,
  AfterOpenDays = 4,
  LifetimeHours = 5,
  LifetimeCycles = 6,
}

export enum LifecycleStartSourceType {
  ManufactureDate = 1,
  ReceivedAt = 2,
  FirstOpenedAt = 3,
  FirstInstalledAt = 4,
}

export enum WorkflowStepType {
  Approval = 1,
  Sourcing = 2,
}

export enum WorkflowResolverType {
  Roles = 1,
  Users = 2,
}

export enum WorkflowStepStatus {
  Pending = 1,
  Completed = 2,
}

export enum WorkflowResolutionStatus {
  Approved = 1,
  Rejected = 2,
  RequestChanges = 3,
}

export enum ProcurementStatus {
  WaitingForResolution = 1,
  Completed = 2,
  Rejected = 3,
}

export enum ProcurementRequestClientStatus {
  Rejected = 1,
  Resolve = 2,
  CreatePO = 3,
  POCreated = 4,
  Draft = 5,
  SubmitChanges = 6,
  Approval = 7,
  Sourcing = 8,
  ChangesRequested = 9,
}

export enum ProcurementPurchaseOrderStatus {
  SendingEmailToSupplier = 1,
  PartiallyReceived = 2,
  Received = 3,
  EmailSentToSupplier = 4,
}

export enum PurchaseRequestItemType {
  ITEM = 1,
  TEXT = 2,
}

export enum ProcurementPurchaseRequestAuditLogType {
  Created = 1, Updated = 2, Submitted = 3, WorkflowStepResolved = 4, WinningQuoteSelected = 5, TextItemsResolved = 6, QuoteCreated = 7
}